import { get, destroy, upload, uploadPut } from 'utils/fetchRequest';

export const getQuotes = async (search) => {
    try {
        return await get(`quotes${search ? `?search=${search}` : ''}`);
    } catch (err) {
        return { error: err };
    }
};

export const getQuote = async (id) => {
    try {
        return await get(`quotes/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const createQuote = async (formData) => {
    try {
        return await upload('quotes', formData);
    } catch (err) {
        return { error: err };
    }
};

export const updateQuote = async (id, formData) => {
    try {
        return await uploadPut(`quotes/${id}`, formData);
    } catch (err) {
        return { error: err };
    }
};

export const deleteQuote = async (id) => {
    try {
        return await destroy(`quotes/${id}`);
    } catch (err) {
        return { error: err };
    }
};